import { render, staticRenderFns } from "./RequestHallModal.vue?vue&type=template&id=2923dc6b&lang=pug&"
import script from "./RequestHallModal.vue?vue&type=script&lang=js&"
export * from "./RequestHallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports